// ink-component
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { newFormSectionTokens } from '../../../../tokens/components/NewFormSection/tokens';

const NewFormSectionLegend = styled.legend`
  border-bottom: ${newFormSectionTokens.DividerThicknessBaseDefault} solid
    ${newFormSectionTokens.DividerColorBaseDefault};
  font-size: ${newFormSectionTokens.FontSizeTitleDefault};
  font-weight: ${newFormSectionTokens.FontWeightTitleDefault};
  line-height: ${newFormSectionTokens.FontLeadingTitleDefault};
  padding-bottom: 8px;
  margin-bottom: 8px;
  width: 100%;
`;

export interface NewFormSectionTitleProps extends HTMLAttributes<HTMLLegendElement> {}

/**
 * @purpose Entitles a section of the form
 * @categories form
 * @group NewFormSection
 * @position 2
 * @HTMLType HTMLLegendElement
 */

function NewFormSectionTitle(props: NewFormSectionTitleProps) {
  const { children, style, className, ...otherProps } = props;

  return <NewFormSectionLegend {...otherProps}>{children}</NewFormSectionLegend>;
}

NewFormSectionTitle.displayName = 'NewFormSection.Title';

export default NewFormSectionTitle;
